export default __webpack_public_path__ + "static/lfx-mentorship-8ca17d8626fd0218ff03b6c547699ced.png";